import styled from "styled-components"

const BaseElement = styled.div`
  width: 100%;
  
  header-area {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 3px;
    border-radius: 3px;
    ${(clickable) => clickable && `
      cursor: pointer;
      &:hover {
        background: #b247eb4f;        
      }
    `}

    & > span {
      color: ${({error}) => error ? '#d3302f' : '#2c2c2c'};
      font-weight: bolder;
      text-transform: capitalize;
      small {
        color: grey;
      }
    }
    & > div {
      display: flex;
      align-items: center;
      display: flex;
      svg {
        width: 18px;
        height: 18px;
      }
      button {
        padding: 2px;
      }
    }
  }

  section-content {
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    border-left: 3px solid #e0e0e0;
  }
`

export default BaseElement